import { Button, Col, Row } from 'antd'
import React from 'react'
import './ServicesDescription.scss'
const ServicesDescription = ({t}) => {
    const data1 =[
        {
            title: t.XRConsultation,
            description: t.XRConsultationDesc, 
        },
        {
            title: t.RequirementsAnalysis,
            description: t.RequirementsAnalysisDesc, 
        },
        {
            title: t.ConceptDevelopment,
            description: t.ConceptDevelopmentDesc, 
        }
    ]
        
    const data2 = [
        {
            title: t.InstructionalDesignProcess,
            description: t.InstructionalDesignProcessDesc, 
        },
        {
            title: t.XRApplicationDevelopment,
            description: t.XRApplicationDevelopmentDesc, 
        },
        {
            title: t.DModelingandAnimation,
            description: t.DModelingandAnimationDesc, 
        },
        {
            title: t.UIUXDesign,
            description: t.UIUXDesignDesc, 
        },
        {
            title: t.IntegrationServices,
            description: t.IntegrationServicesDesc, 
        },
        {
            title: t.QualityAssurance,
            description: t.QualityAssuranceDesc, 
        }
    ]
    const data3 = [
        {
            title: t.DeploymentServices,
            description: t.DeploymentServicesDesc, 
        },
        {
            title: t.MaintenanceandSupport,
            description: t.MaintenanceandSupportDesc, 
        },
        {
            title: t.UserTraining,
            description: t.UserTrainingDesc, 
        },
        {
            title: t.AnalyticsandReporting,
            description: t.AnalyticsandReportingDesc, 
        },
        {
            title: t.ScalabilityPlanning,
            description: t.ScalabilityPlanningDesc, 
        },

    ]
  return (
    <div className="services-description">
        <div className="container">
            <div className="content">
                <div className="services-description-cards">
                        
                                <div className="service-card">
                    <Row>
                        <Col sm={24} md={24} lg={12} xl={12} xxl={12}>
                                    {
                                        data1.map((item, index) => {
                                            return (
                                                <div className="card" key={index}>
                                                    <h3 className="card-title-services">
                                                        {item?.title}
                                                    </h3>
                                                    <p className="card-text-services">
                                                        {item?.description}
                                                    </p>
                                                </div>
                                            )
                                        })
                                    }

                        </Col>
                        <Col sm={24} md={24} lg={12} xl={12} xxl={12}>
                         <div className="info-services">
                            <div className="info-services-inner">
                          <h1 className="title-services">{t.We}</h1>
                          <h1 className="sub-title-services">{t.Plan}</h1>
                            </div>
                         </div>
                        </Col>
                    </Row>
                                </div>


                </div>
                <div className="services-description-cards">
                        
                                <div className="service-card">
                    <Row>
                        <Col sm={24} md={24} lg={12} xl={12} xxl={12}>
                                    {
                                        data2.map((item, index) => {
                                            return (
                                                <div className="card" key={index}>
                                                    <h3 className="card-title-services">
                                                        {item?.title}
                                                    </h3>
                                                    <p className="card-text-services">
                                                        {item?.description}
                                                    </p>
                                                </div>
                                            )
                                        })
                                    }

                        </Col>
                        <Col sm={24} md={24} lg={12} xl={12} xxl={12}>
                         <div className="info-services">
                         <div className="info-services-inner">
                          <h1 className="title-services">{t.Then} </h1>
                          <h1 className="sub-title-services">{t.BUILD}</h1>
                         </div>
                         </div>
                        </Col>
                    </Row>
                                </div>


                </div>
                <div className="services-description-cards">
                        
                                <div className="service-card">
                    <Row>
                        <Col sm={24} md={24} lg={12} xl={12} xxl={12}>
                                    {
                                        data3.map((item, index) => {
                                            return (
                                                <div className="card" key={index}>
                                                    <h3 className="card-title-services">
                                                        {item?.title}
                                                    </h3>
                                                    <p className="card-text-services">
                                                        {item?.description}
                                                    </p>
                                                </div>
                                            )
                                        })
                                    }

                        </Col>
                        <Col sm={24} md={24} lg={12} xl={12} xxl={12}>
                         <div className="info-services">
                         <div className="info-services-inner">
                          <h1 className="title-services">{t.AND} </h1>
                          <h1 className="sub-title-services">{t.RUN}</h1>
                         </div>
                         </div>
                        </Col>
                    </Row>
                                </div>


                </div>
                <div className="btn-hero"
                  style={{
                    marginTop: "80px",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                    <Button type="primary"  className="btn-hero" >{t.ContactUs}</Button>
                </div>
            </div>
        </div>
    </div>
  )
}

export default ServicesDescription